var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Drawer",
        {
          attrs: { drawer: _vm.drawer, withHeader: false, size: 1177 },
          on: { close: _vm.close },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "view",
            },
            [
              _c("div", { staticClass: "header" }, [
                _c("div", { staticClass: "left" }, [
                  _vm.billType !== 1
                    ? _c(
                        "span",
                        {
                          staticClass: "title",
                          class: [_vm.active === 0 ? "active" : ""],
                          on: {
                            click: function ($event) {
                              return _vm.changeType(0)
                            },
                          },
                        },
                        [_vm._v("船司轨迹")]
                      )
                    : _vm._e(),
                  _c(
                    "span",
                    {
                      staticClass: "title",
                      class: [_vm.active === 1 ? "active" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.changeType(1)
                        },
                      },
                    },
                    [_vm._v("清关轨迹")]
                  ),
                ]),
                _c("i", {
                  staticClass: "el-icon-close icon",
                  on: { click: _vm.close },
                }),
              ]),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active === 0,
                        expression: "active === 0",
                      },
                    ],
                    staticClass: "table",
                  },
                  [
                    _vm.height
                      ? _c("BaseTable", {
                          attrs: {
                            height: _vm.height,
                            tableData: _vm.tableData,
                            isPager: false,
                            border: true,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.active === 1,
                        expression: "active === 1",
                      },
                    ],
                    staticClass: "table qg-list",
                  },
                  [
                    _c("div", { staticClass: "ams" }, [
                      _c("div", { staticClass: "top" }, [
                        _c("div", { staticClass: "tips" }),
                        _vm._v(" AMS轨迹 "),
                      ]),
                      _c(
                        "div",
                        { staticClass: "amsList" },
                        _vm._l(_vm.amsData, function (item, $index) {
                          return _c(
                            "div",
                            { key: $index, staticClass: "list" },
                            [
                              _c("div", { staticClass: "list-top" }, [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("提单号："),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(item.number)),
                                  ]),
                                ]),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("类型："),
                                  _c(
                                    "span",
                                    {
                                      class: [
                                        "value",
                                        item.blType === "M"
                                          ? "Master"
                                          : "House",
                                      ],
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.blType === "M"
                                            ? "Master"
                                            : "House"
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                !_vm.rowData.type
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v("ISF On File："),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "value",
                                          style: {
                                            color: item.isf
                                              ? "#333333"
                                              : "#FE453D",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(item.isf ? "YES" : "NO")
                                          ),
                                        ]
                                      ),
                                    ])
                                  : _vm._e(),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("数量："),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(item.qty)),
                                  ]),
                                ]),
                                !_vm.rowData.type
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v("船名："),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(_vm._s(item.vesselName)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                !_vm.rowData.type
                                  ? _c("span", { staticClass: "label" }, [
                                      _vm._v("船次："),
                                      _c("span", { staticClass: "value" }, [
                                        _vm._v(_vm._s(item.voyageNumber)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("到达日期："),
                                  _c("span", { staticClass: "value" }, [
                                    _vm._v(_vm._s(item.lastRunTime)),
                                  ]),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "list-middle" },
                                _vm._l(
                                  item.truckItems,
                                  function (event, index) {
                                    return _c("div", { key: index }, [
                                      _c("span", { staticClass: "icon" }, [
                                        _vm._v(_vm._s(event.dispositionCode)),
                                        _c("img", {
                                          attrs: {
                                            src: require("@/assets/images/bill/qun.png"),
                                          },
                                        }),
                                      ]),
                                      _c("span", { staticClass: "desc" }, [
                                        _vm._v(
                                          " " +
                                            _vm._s(event.dispositionDesc) +
                                            " "
                                        ),
                                      ]),
                                      _c("span", { staticClass: "quantity" }, [
                                        _vm._v(
                                          " Quantity： " +
                                            _vm._s(event.manifestQuantity) +
                                            " "
                                        ),
                                      ]),
                                      _c("span", { staticClass: "quantity" }, [
                                        _vm._v(
                                          " " + _vm._s(event.eventDate) + " "
                                        ),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "div",
                { staticClass: "foooter flex_c_c" },
                [
                  !_vm.active
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "debounce-click",
                              rawName: "v-debounce-click",
                              value: _vm.reloadship,
                              expression: "reloadship",
                            },
                          ],
                          staticClass: "ok flex_c_c",
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/bill/reload.png"),
                            },
                          }),
                          _c(
                            "span",
                            { staticStyle: { "margin-left": "4px" } },
                            [_vm._v("刷新")]
                          ),
                        ]
                      )
                    : [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "debounce-click",
                                rawName: "v-debounce-click",
                                value: { value: _vm.reload, args: [1] },
                                expression: "{ value: reload, args: [1] }",
                              },
                            ],
                            staticClass: "ok flex_c_c",
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/bill/reload.png"),
                              },
                            }),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "4px" } },
                              [_vm._v("刷新")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "debounce-click",
                                rawName: "v-debounce-click",
                                value: { value: _vm.reSub, args: [1] },
                                expression: "{ value: reSub, args: [1] }",
                              },
                            ],
                            staticClass: "ok flex_c_c",
                            staticStyle: { "margin-left": "20px" },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/images/bill/reload.png"),
                              },
                            }),
                            _c(
                              "span",
                              { staticStyle: { "margin-left": "4px" } },
                              [_vm._v("重新订阅")]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }